import { AlertTriangle } from 'react-feather';
import type { ToastComponentProps } from './interfaces';
import styles from './style.module.css';
import * as Toast from './Toast.Base';

type Props = ToastComponentProps;

export const Warn = (props: Props) => {
  return (
    <Toast.Base
      Icon={AlertTriangle}
      iconClassName={styles.warn}
      iconSize={18}
      body={props.body}
      title={props.title} />
  );
};

Warn.displayName = 'Toast.Warn';